export default function getStyle(param) {
    var theme = param.theme;
    return {
        badge: {
            base: {
                boxSizing: 'border-box',
                borderRadius: theme.size.border.radius.round,
                paddingLeft: 6,
                paddingRight: 6,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 20,
                minWidth: 20,
                fontFamily: theme.font.base.family,
                fontSize: theme.font.base.size.s,
                lineHeight: theme.font.lineHeight.base
            }
        },
        indicator: {
            base: {
                height: 10,
                width: 10,
                borderRadius: theme.size.border.radius.round,
                display: 'inline-block',
                transform: 'translateY(-4px)'
            }
        },
        danger: {
            color: theme.font.color.danger.fill,
            backgroundColor: theme.backgroundColor.danger.fill.base
        },
        tertiary: {
            color: theme.font.color.tertiary.fill,
            backgroundColor: theme.backgroundColor.tertiary.fill.base
        }
    };
};
